import React from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, FormControlLabel, FormGroup, Radio, Stack, Typography } from '@mui/material';
import { COLORS } from 'shared/constants/AppEnums';
import { red } from '@mui/material/colors';

export function SoalSection({
    data,
    pilihan = [],
    pertanyaan = '',
    tipe = 'one-choice', // one-choice for only one choice acceptable || multi-choices for multi choices acceptable
    onClick = () => { },
    validation = []
}) {

    const getCheckedstatus = (val, key) => {
        const realKey = key.split('. ')[1].replace(':', '');
        if (data[realKey].includes(val)) return true;
        else return false
    }

    const getValidation = (val) => {
        const realKey = val.split('. ')[1].replace(':', '');
        if (validation.includes(realKey)) {
            return <Typography color={red[600]}>Mohon Masukan Survey dengan Benar</Typography>
        } else {
            return null
        }
    }

    return (
        <Box>
            <Stack sx={{ mb: 2 }}>
                <Typography sx={{ fontSize: '16px', fontWeight: 500 }} spacing={2}>{pertanyaan}</Typography>
                {getValidation(pertanyaan)}
            </Stack>
            {tipe === 'multi-choices' ? (
                <FormGroup sx={{ ml: 3 }}>
                    {
                        pilihan && pilihan.map((item, index) => (
                            <FormControlLabel
                                key={`${index}-${item}`}
                                control={
                                    <Checkbox
                                        size='small'
                                        checked={getCheckedstatus(item, pertanyaan)}
                                        onChange={(e) => onClick(pertanyaan, e.target.value)}
                                        value={item}
                                        sx={{
                                            '&.Mui-checked': {
                                                color: COLORS.primary,
                                            },
                                        }}
                                    />
                                }
                                label={item}
                            />
                        ))
                    }
                </FormGroup>

            ) : (

                pilihan && pilihan.sort((a, b) => b.value - a.value).map((item, index) => (
                    <Stack direction={'row'} gap={3} alignItems={'center'} key={`${index}-${item.value}`} height={'1.9rem'}>
                        <Radio
                            size='small'
                            value={item.value}
                            checked={getCheckedstatus(item.value, pertanyaan)}
                            onChange={(e) => onClick(pertanyaan, e.target.value)}
                            sx={{
                                '&.Mui-checked': {
                                    color: COLORS.primary,
                                },
                            }}
                        />
                        <Typography sx={{ fontSize: '15px' }}>{item.label}</Typography>
                    </Stack>
                ))
            )}
        </Box>
    )
}

SoalSection.propTypes = {
    data: PropTypes.object,
    tipe: PropTypes.string,
    checked: PropTypes.bool,
    onClick: PropTypes.func,
    pilihan: PropTypes.array,
    pertanyaan: PropTypes.string,
    validation: PropTypes.array
}